import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './AuthPages.css';

function RegisterPage({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setIsLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          password: formData.password
        })
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        onLoginSuccess(data.user);
        navigate('/editor');
      } else {
        setError(data.error || 'Registration failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <img src="/logo.png" alt="LaTeXLaB" className="auth-logo" />
          <h1>Start Your Free Trial</h1>
          <p className="auth-subtitle">Register and get 1 month free • 50 compilations/month</p>

          {error && <div className="error-message">{error}</div>}
          <div style={{background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:'10px',padding:'14px 16px',marginBottom:'18px',fontSize:'13px'}}>
            <div style={{fontWeight:'700',color:'#166534',marginBottom:'8px',fontSize:'14px'}}>✅ What you get with Free Account:</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px',color:'#15803d'}}>
              <span>📁 5 Projects</span>
              <span>⚡ 50 Compilations/month</span>
              <span>💾 Auto-save</span>
              <span>📦 ZIP Upload</span>
              <span>📄 30+ Templates</span>
              <span>🔧 Multi-file Support</span>
            </div>
            <div style={{marginTop:'10px',paddingTop:'8px',borderTop:'1px solid #bbf7d0',color:'#6b7280',fontSize:'12px'}}>
              👤 Guest (no signup): Only 3 compilations/day, no project saving
            </div>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your name"
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="At least 6 characters"
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                placeholder="Re-enter your password"
                disabled={isLoading}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary btn-full"
              disabled={isLoading}
            >
              {isLoading ? 'Creating account...' : 'Create Free Account'}
            </button>
          </form>

          <p className="auth-footer">
            Already have an account? <Link to="/login">Login</Link>
          </p>

          <p className="auth-footer">
            <Link to="/editor" className="guest-link">
              Or try without signing up →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
